/**
 * Internal path to come back to after login, or null.
 *
 * Only the OAuth consent screen of the MCP server (`/oauth/…`) must survive the login: everything
 * else, an external URL, `//host`, a path to another part of the dashboard, falls back to the home page.
 * Without this narrow list, `?redirect=` would turn the login page into an open redirect.
 *
 * @param {unknown} value
 * @returns {string|null}
 */
export const safeRedirectPath = (value) => {
  if (typeof value !== "string" || !value.startsWith("/oauth/")) return null;
  try {
    const base = "https://redirect.invalid";
    const url = new URL(value, base);
    return url.origin === base && url.pathname.startsWith("/oauth/") ? value : null;
  } catch {
    return null;
  }
};
